import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_135: FaireProductEntity = {
  token: "legacy_prod_abbott-135",
  type: "product",
  name: "Blue and White Umbrella Stand-18 H 6 D",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/be882c70fdafde3609a8408377a51228503f15be424cb2718e198e50846f6f20.jpeg",
  priceDollars: 48,
  subcategory: "Decorative Objects",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_home-accents"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
